const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        x={0}
        y={0}
        viewBox="0 0 18 18"
        style={{
            // @ts-ignore
            enableBackground: 'new 0 0 18 18',
        }}
        xmlSpace="preserve"
        {...props}
    >
        <style>{'.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#878d99}'}</style>
        <g id="\u6700\u7EC8\u7A3F">
            <g
                transform="translate(-160 -1217)"
            >
                <g
                    transform="translate(78 1200)"
                >
                    <g transform="translate(82 17)">
                        <circle
                            cx={8}
                            cy={6.5}
                            r={2.5}
                            style={{
                                fill: 'none',
                                stroke: '#878d99',
                            }}
                        />
                        <path
                            d="M8 14H5c-.6 0-1-.4-1-1v-1h0c0-1.7 1.3-3 3-3h2c1 0 1.9.5 2.5 1.3"
                            style={{
                                fill: 'none',
                                stroke: '#878d99',
                                strokeLinecap: 'round',
                            }}
                        />
                        <path
                            className="st2"
                            d="M10 12h3c.3 0 .5.2.5.5s-.2.5-.5.5h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5z"
                        />
                        <path
                            className="st2"
                            d="M10 14h3c.3 0 .5.2.5.5s-.2.5-.5.5h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5z"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default SvgComponent;
